import { ExternalLink } from "lucide-react";

import { Document } from "@/taskpane/types/Document";

export interface DocumentBadgeProps {
  document: Partial<Document>;
}

export function DocumentBadge({ document: { metadata } }: DocumentBadgeProps) {
  if (!metadata?.doc_id || !matchLegifranceId(metadata?.doc_id || "")) {
    return null;
  }

  const link = `https://www.legifrance.gouv.fr/loda/id/${metadata.doc_id}`;
  return (
    // <div className='tooltip tooltip-top' data-tip={doc.content}>
    <a
      href={link}
      target="_blank"
      rel="noopener noreferrer"
      className="badge badge-secondary badge-sm badge-outline cursor-pointer transition-all hover:bg-secondary hover:text-secondary-content hover:border-secondary"
    >
      <ExternalLink className="w-3 h-3" />
      {metadata?.title || "source"}
    </a>
    // </div>
  );
}

/**
 * Does id match legifrance france
 * @param id - the id to match, e.g. "legiarti000006528989"
 * @returns boolean - true if id matches the pattern, false otherwise
 */
function matchLegifranceId(id: string): boolean {
  // LegiFrance article IDs are "legiarti" followed by 12 to 20 digits (semi-standard).
  return /^[a-zA-Z]+\d{12,20}$/.test(id);
}
